var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "question-display" },
    [
      _c("div", { staticClass: "sr-only" }, [
        _c("p", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.questionNumber", {
                  number: _vm.activeQuestion.index + 1
                })
              ) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pull-right" }, [
        _c("span", { staticClass: "pill pill-dark" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.pointsPossible", {
                  points: _vm.activeQuestion.TOTAL_POINTS
                })
              ) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-type-instructions" }, [
        _c("strong", [_vm._v(_vm._s(_vm.activeQuestion.QUESTION_NAME))]),
        _vm._v(" "),
        _c("span", { staticClass: "hint" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.$t("MAIN_CONTENT.EssayQuestion.enterYourAnswer")) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("h3", {
        staticClass: "question-text",
        domProps: { innerHTML: _vm._s(_vm.activeQuestion.QUESTION_TEXT) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "answers" }, [
        _c("div", { class: ["answer", _vm.getAnswerClass()] }, [
          _c(
            "div",
            { class: ["answer-number", { selected: _vm.answeredByStudent() }] },
            [
              _vm.answeredByStudent()
                ? _c("i", { staticClass: "fa fas fa-arrow-circle-right" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "answer-text form" }, [
            !this.isGraded()
              ? _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.answerData.answer[0].TEST_QUESTION_ANSWER_TEXT,
                      expression:
                        "answerData.answer[ 0 ].TEST_QUESTION_ANSWER_TEXT"
                    }
                  ],
                  ref: "answerRef",
                  staticClass: "form-control",
                  staticStyle: { "min-width": "400px", height: "200px" },
                  domProps: {
                    value: _vm.answerData.answer[0].TEST_QUESTION_ANSWER_TEXT
                  },
                  on: {
                    blur: function($event) {
                      return _vm.answerTheQuestion()
                    },
                    keyup: function($event) {
                      return _vm.schedAnswerTheQuestion()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.answerData.answer[0],
                        "TEST_QUESTION_ANSWER_TEXT",
                        $event.target.value
                      )
                    }
                  }
                })
              : _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.answerData.answer[0].TEST_QUESTION_ANSWER_TEXT
                    )
                  }
                })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grade-result" }, [
            _c("i", { class: _vm.getFeedbackIcon() })
          ])
        ]),
        _vm._v(" "),
        !this.isGraded(_vm.activeQuestion)
          ? _c("div", [
              _c("small", [
                _vm.answerTooShort || _vm.answerTooLong
                  ? _c("span", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.EssayQuestion.minMaxPointsMessage",
                              {
                                min: _vm.activeQuestion.MIN_LENGTH,
                                max: _vm.activeQuestion.MAX_LENGTH
                              }
                            )
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("question-summary"),
      _vm._v(" "),
      _vm.testMode !== "grading"
        ? _c("test-buttons", { on: { "answer-save": _vm.submitAnswer } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }